import { useId } from "react";

import { Button, Input, Label } from "@bigbinary/neeto-atoms";
import classnames from "classnames";
import { Form, Formik, useField } from "formik";
import { getQueryParams } from "neetocommons/utils";
import { assoc } from "ramda";
import { useTranslation } from "react-i18next";

import { INITIAL_FORM_VALUES, LOGIN_FORM_VALIDATION_SCHEMA } from "./constants";

const FormikInput = ({ name, label, ...props }) => {
  const [field, meta] = useField(name);
  const id = useId();
  const hasError = meta.touched && meta.error;

  return (
    <div className="flex flex-col gap-1.5">
      {label && <Label htmlFor={id}>{label}</Label>}
      <Input
        {...{ id, ...field, ...props }}
        aria-invalid={!!hasError}
        className={classnames({
          "border-destructive": hasError,
          "": !hasError,
        })}
      />
      {hasError && <p className="text-destructive text-sm">{meta.error}</p>}
    </div>
  );
};

const SignInForm = ({ handleFormSubmit }) => {
  const { t } = useTranslation();
  const { email = "" } = getQueryParams();

  const emailPrefilledInitialValues = () =>
    assoc("email", email, INITIAL_FORM_VALUES);

  return (
    <Formik
      initialValues={emailPrefilledInitialValues()}
      validationSchema={LOGIN_FORM_VALIDATION_SCHEMA}
      onSubmit={handleFormSubmit}
    >
      <Form className="flex w-full flex-col gap-y-6">
        <FormikInput
          data-testid="login-email-text-field"
          label={t("neetoMolecules.login.email")}
          name="email"
        />
        <FormikInput
          data-testid="login-password-text-field"
          label={t("neetoMolecules.login.password")}
          name="password"
          type="password"
        />
        <Button
          className="w-full"
          data-testid="login-submit-button"
          size="lg"
          type="submit"
          variant="secondary"
        >
          {t("neetoMolecules.login.login")}
        </Button>
      </Form>
    </Formik>
  );
};

export default SignInForm;
